import ErrorBoundary from './ErrorBoundary';
import { useCardRenderMarkers } from 'crm-cards-sdk/hooks/useCardRenderMarkers';
import { jsx as _jsx } from "react/jsx-runtime";
export const withErrorBoundary = Component => {
  const WithErrorBoundary = props => /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorMarker: props.ErrorMarker,
    objectId: props.objectId,
    objectType: props.objectType,
    objectTypeId: props.objectTypeId,
    children: /*#__PURE__*/_jsx(Component, Object.assign({}, props))
  });
  return WithErrorBoundary;
};
export const withErrorBoundarySdk = Component => {
  const WithErrorBoundarySDK = props => {
    const {
      ErrorMarker
    } = useCardRenderMarkers();
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      ErrorMarker: ErrorMarker,
      objectId: props.objectId,
      objectType: props.objectType,
      objectTypeId: props.objectTypeId,
      children: /*#__PURE__*/_jsx(Component, Object.assign({}, props))
    });
  };
  return WithErrorBoundarySDK;
};